import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { publicAPI, swapAPI } from '@/utils/api'

export const usePriceStore = defineStore('price', () => {
  const currentPrice  = ref(0.01)
  const initialPrice  = ref(0.01)
  const priceMultiple = ref(1)
  const priceChange24h = ref('0%')
  const priceHistory  = ref([])
  const buySlippage   = ref(0.30) // 30% per requirements
  const sellSlippage  = ref(0.30)

  const multipleLabel = computed(() => {
    const m = priceMultiple.value
    if (m >= 100) return '100x+'
    if (m >= 10)  return `${m.toFixed(1)}x`
    return `${m.toFixed(2)}x`
  })

  // GET /public/price
  async function loadPriceInfo() {
    try {
      const res = await publicAPI.getPrice()
      const d = res.data || {}
      currentPrice.value   = parseFloat(d.current_price)  || 0.01
      initialPrice.value   = parseFloat(d.initial_price)  || 0.01
      priceMultiple.value  = parseFloat(d.price_multiple) || 1
      priceChange24h.value = d.price_change_24h || '0%'
    } catch (e) {
      console.error('[price] loadPriceInfo failed', e)
    }
  }

  // GET /swap/price/history
  async function loadPriceHistory(interval = '1d', limit = 100) {
    try {
      const res = await swapAPI.getPriceHistory({ interval, limit })
      priceHistory.value = res.data?.history || []
    } catch (e) {
      console.error('[price] loadPriceHistory failed', e)
    }
  }

  function estimateBuyUK(usdtAmount) {
    if (currentPrice.value <= 0) return 0
    const afterFee = usdtAmount * (1 - buySlippage.value)
    return afterFee / currentPrice.value
  }

  function estimateSellUSDT(ukAmount) {
    const gross = ukAmount * currentPrice.value
    return gross * (1 - sellSlippage.value)
  }

  return {
    currentPrice, initialPrice, priceMultiple, priceChange24h,
    priceHistory, buySlippage, sellSlippage, multipleLabel,
    loadPriceInfo, loadPriceHistory, estimateBuyUK, estimateSellUSDT,
  }
})
